import { useState } from "react";

import EmptyPlaceholder from "common/components/EmptyPlaceholder";
import ErrorPlaceholder from "common/components/ErrorPlaceholder";
import Loader from "common/components/Loader";
import SearchInput from "common/components/SearchInput";
import { Button } from "common/components/ui/Button";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

import useWebhooks from "../../datahooks/useWebhooks";
import MobileList from "./MobileLayout/MobileList";
import NewWebhookButton from "./NewWebhookButton";
import WebhooksDesktopTable from "./WebhooksDesktopTable";

import NoResultsImage from "assets/images/empty-placeholders/result-not-found.png";
import EmptyPlaceholderImage from "assets/images/empty-placeholders/webhooks.png";

export default function Webhooks() {
  const isDesktop = useTwBreakpoint("lg");
  const [searchTerm, setSearchTerm] = useState("");

  const { webhooks, isLoadingWebhooks, isWebhooksError, refetchWebhooks } =
    useWebhooks();

  if (isWebhooksError) {
    return (
      <ErrorPlaceholder
        errorMessage="Could not display webhooks"
        onRetry={refetchWebhooks}
      />
    );
  } else if (isLoadingWebhooks) {
    return <Loader />;
  } else if (!webhooks?.length) {
    return (
      <EmptyPlaceholder
        imageSrc={EmptyPlaceholderImage}
        title="No webhooks found"
        subtitle="Add a webhook to connect Aimfox with your application"
        actionComponent={<NewWebhookButton size="md" />}
      />
    );
  }

  const filteredWebhooks = webhooks.filter((webhook) =>
    webhook.name.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const Component = isDesktop ? WebhooksDesktopTable : MobileList;

  return (
    <>
      <SearchInput
        placeholder="Search webhooks"
        value={searchTerm}
        className="lg:max-w-80"
        variant={isDesktop ? "sm" : "lg"}
        onChange={(e) => setSearchTerm(e.target.value)}
        onClear={() => setSearchTerm("")}
      />
      {filteredWebhooks.length ? (
        <Component webhooks={filteredWebhooks} />
      ) : (
        <EmptyPlaceholder
          title="No webhooks found"
          subtitle="No webhooks match your search criteria. Try adjusting your search"
          imageSrc={NoResultsImage}
          actionComponent={
            <Button onClick={() => setSearchTerm("")}>Clear search</Button>
          }
        />
      )}
    </>
  );
}
